import { useEffect, useMemo } from 'react';
import { useStoreon } from 'storeon/react';
import { FETCH_FAVORITE_ADDRESS } from 'actions';
import { isFavoriteAddressEnabled } from 'selectors';
import { FavoriteAddressViewState } from 'types/favorite-address';
import { State } from 'store/types';

export const useFavoriteAddress = (): FavoriteAddressViewState => {
  const { cookies, dispatch, orchestratorHost, favoriteAddress } = useStoreon<State>(
    'cookies',
    'dispatch',
    'orchestratorHost',
    'favoriteAddress',
  );
  const enabled = isFavoriteAddressEnabled(cookies);

  useEffect(() => {
    dispatch(FETCH_FAVORITE_ADDRESS.init);
  }, [enabled, dispatch, orchestratorHost]);

  return useMemo(
    () => ({
      enabled,
      loading: favoriteAddress.loading,
      favoriteAddress: favoriteAddress.data,
    }),
    [enabled, favoriteAddress.loading, favoriteAddress.data],
  );
};
